export {
  DatastoreCurrenciesIncludingExternalModule,
} from './currencies-including-external.module';
